import { useEffect, useState } from "react";
import styles from "../../../ProductsDetails.module.css";
import { useTranslation } from "react-i18next";
import AnimatedDetailsText from "../../../AnimatedDetailsText";
import ModelSlider from "../../../ModelSlider";

function AirFunctionSensors() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  // const [imagesLoaded, setImagesLoaded] = useState({});
  const { i18n } = useTranslation(); // إضافة i18n للحصول على 

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const handleImageLoad = (index) => {
  //   setImagesLoaded((prevState) => ({
  //     ...prevState,
  //     [index]: true,
  //   }));
  // };
  const { t } = useTranslation();

  // const basePath = `${process.env.PUBLIC_URL}/images/02-tis-air/sensors/details/10-function-sensors`;
  // const smallScreenPath = `${basePath}/smallScreens`;

  const imageBasePath = isSmallScreen
  ? `${process.env.PUBLIC_URL}/images/02-tis-air/sensors/details/10-function-sensors/smallScreens`
  : `${process.env.PUBLIC_URL}/images/02-tis-air/sensors/details/10-function-sensors`

const modelBasePath = `${process.env.PUBLIC_URL}/images/02-tis-air/sensors/details/10-function-sensors`

const videoBasePath = `${process.env.PUBLIC_URL}/images/02-tis-air/sensors/details/10-function-sensors`

  const mediaData = [
    {
      type: "image",
      src: isSmallScreen ? "01.jpg" : "01.jpg",
      title: "",
      subtitle: t(`air10FunctionSensor.subtitle1`),
      
      top: isSmallScreen ? "15%" : "15%",
      left: isSmallScreen ? "50%" : "50%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "70%" : "60%",
      direction: isSmallScreen ? "up" : "down",
      zoom: true,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "video",
      src: "02.mp4",
      title: "",
      subtitle: ``,
      top: isSmallScreen ? "20%" : "15%",
      left: isSmallScreen ? "52%" : "50%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "70%" : "50%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "image",
      src: isSmallScreen ? "03.jpg" : "03.jpg",
      title: "",
      subtitle: t(`air10FunctionSensor.subtitle3`),
      
      top: isSmallScreen ? "25%" : "12%",
      left: isSmallScreen ? "50%" : "50%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "50%" : "35%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },

    {
      type: "video",
      src: "04.mp4",
      title: "",
      subtitle: ``,
      top: isSmallScreen ? "17%" : "50%",
      left: isSmallScreen ? "50%" : "25%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "60%" : "30%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "image",
      src: isSmallScreen ? "05.jpg" : "05.jpg",
      title: "",
      subtitle: t(`air10FunctionSensor.subtitle5`),
      
      top: isSmallScreen ? "26%" : "40%",
      left: isSmallScreen ? "52%" : "25%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "60%" : "30%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#fff" : "#fff",
    },
    {
      type: "video",
      src: "06.mp4",
      title: "",
      subtitle: t(`air10FunctionSensor.subtitle6`),
      
      top: isSmallScreen ? "38%" : "40%",
      left: isSmallScreen ? "50%" : "50%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "85%" : "35%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#fff" : "#fff",
    },
    {
      type: "image",
      src: isSmallScreen ? "07.jpg" : "07.jpg",
      title: t(`air10FunctionSensor.title7`),
      subtitle: t(`air10FunctionSensor.subtitle7`),

      top: isSmallScreen ? "25%" : "15%",
      left: isSmallScreen ? "50%" : "50%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "85%" : "60%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "image",
      src: isSmallScreen ? "08.jpg" : "08.jpg",
      title: "",
      subtitle: t(`air10FunctionSensor.subtitle8`),
      
      top: isSmallScreen ? "20%" : "40%",
      left: isSmallScreen ? "50%" : "75%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "85%" : "35%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "image",
      src: isSmallScreen ? "09.jpg" : "09.jpg",
      title: "",
      subtitle: t(`air10FunctionSensor.subtitle9`),
      
      top: isSmallScreen ? "20%" : "20%",
      left: isSmallScreen ? "50%" : "80%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "65%" : "30%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#fff",
    },
    {
      type: "video",
      src: "10.mp4",
      title: "",
      subtitle: ``,
      top: isSmallScreen ? "20%" : "10%",
      left: isSmallScreen ? "50%" : "50%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "85%" : "40%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "video",
      src: "11.mp4",
      title: "",
      subtitle:isSmallScreen? "" :t(`air10FunctionSensor.subtitle11`),
      
      top: isSmallScreen ? "30%" : "40%",
      left: isSmallScreen ? "50%" : "77%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "50%" : "30%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "image",
      src: isSmallScreen ? "12.jpg" : "12.jpg",
      title: "",
      subtitle: t(`air10FunctionSensor.subtitle12`),
      
      top: isSmallScreen ? "50%" : "50%",
      left: isSmallScreen ? "50%" : "50%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "85%" : "40%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#fff" : "#fff",
    },
    {
      type: "image",
      src: isSmallScreen ? "13.jpg" : "13.jpg",
      title: "",
      subtitle: t(`air10FunctionSensor.subtitle13`),
      
      top: isSmallScreen ? "15%" : "10%",
      left: isSmallScreen ? "50%" : "50%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "85%" : "60%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "video",
      src: "14.mp4",
      title: "",
      subtitle: t(`air10FunctionSensor.subtitle14`),
      
      top: isSmallScreen ? "43%" : "50%",
      left: isSmallScreen ? "24%" : "20%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "40%" : "30%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "image",
      src: isSmallScreen ? "15.jpg" : "15.jpg",
      title: "",
      subtitle: t(`air10FunctionSensor.subtitle15`),
      
      top: isSmallScreen ? "84%" : "70%",
      left: isSmallScreen ? "50%" : "75%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "85%" : "40%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#fff" : "#fff",
    },
  ];



  const modelsData = [
    {
      id: 1,
      name: "AIR-ES-IR",
      image: `${modelBasePath}/models/01.png`,
    },
  ];
  
  const textDirection = i18n.language === "ar" ? "rtl" : "ltr"; // تعيين اتجاه الكتابة بناءً على اللغة
  return (
    <div className={styles.container} style={{ direction: textDirection }}>
      {mediaData.map((item, index) => (
        <div
          key={index}
          className={styles.imgContainer}
          style={{ position: "relative", width: "100%", display: "block" }}
        >
          {item.type === "image" ? (
            <img
              style={{ width: "100%" }}
              src={`${imageBasePath}/${item.src}`}
              alt=""
            />
          ) : (
            <div className={styles.videoContainer}>
              <video
                className={styles.fullscreenVideo}
                src={`${videoBasePath}/${item.src}`}
                autoPlay
                muted
                loop
                playsInline // مهم لأجهزة iPhone
                disablePictureInPicture // منع خاصية "صورة داخل صورة"
                controls={false} // إخفاء أزرار التحكم
                style={{ display: "block", width: "100%" }}
              />
            </div>
          )}
          <div
            style={{
              position: "absolute",
              top: item.top,
              left: item.left,
              transform: "translate(-50%, -50%)",
              textAlign: item.textAlign,
              width: item.width,
              color: item.color || "#000", // استخدام لون النص المحدد
            }}
          >
            <AnimatedDetailsText
              text={{
                title: item.title,
                subtitle: item.subtitle,
              }}
              textAlign={item.textAlign}
              margin="20px 0"
              padding="10px"
              direction={item.direction}
              zoom={item.zoom}
              fontSize="20px"
              color={item.color} // تمرير اللون إلى `AnimatedDetailsText`
            />
          </div>
          {index === 0 && (
            <div style={{ textAlign: "center" }}>
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  marginTop: "40px",
                }}
              >
                Product Models
              </h1>
              <div>
                <ModelSlider models={modelsData} />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default AirFunctionSensors;
